/* eslint-disable import/prefer-default-export */
export const errorsMessages = {
  notAuthenticated: {
    code: '001',
    message: 'Não foi possível autenticar',
  },
  loginInvalid: {
    code: '002',
    message: 'Usuário ou senha inválidos',
  },
};
